<template>
  <div>
    <div class="h2 grey--text mt-2">{{ label }}</div>
    <v-list dense class="primary--text grey lighten-5 ma-0 wdth-98p">
      <v-list-item-group v-model="quick_link">
        <v-list-item
          v-for="(quick_link, i) in quick_links"
          :key="i"
          @click="on_go_to(quick_link)"
        >
          <v-list-item-icon class="text-right mr-1 ml-2">
            <v-icon class="mr-0">mdi-circle</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="text-left">
            <v-list-item-title v-text="quick_link.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "QuickSideLinks",
  props: {
    label: {
      type: String,
      default: "quick page links",
    },
    quick_links: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => {
    return {
      quick_link: "",
    };
  },
  methods: {
    on_go_to(on_go_to) {
      //https://stackoverflow.com/questions/54770883/how-to-navigate-to-different-section-in-the-same-page-using-vuetify
      var options = {
        offset: 102,
        duration: 1000,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo(on_go_to.href, options);
    },
  },
};
</script>